import fs from 'node:fs'
import type { GeneratedFile } from '@cli-types/core-engine/schema.js'
import type { SnapshotManifest } from '@cli-types/core-engine/snapshots.js'
import { snapshotFilePath } from './snapshot-file-path.js'

export function readSnapshotFiles(
  cwd: string,
  scope: string,
  manifest: SnapshotManifest
): GeneratedFile[] {
  return manifest.files
    .filter((entry) => fs.existsSync(snapshotFilePath(cwd, scope, entry.path)))
    .map((entry) => ({
      path: entry.path,
      content: fs.readFileSync(snapshotFilePath(cwd, scope, entry.path), 'utf-8')
    }))
}
